import { SnLonLatBounds, SnLonLatBoundsLike } from '@lib/geo/helpers';

export abstract class BaseBoundsManagementService {
  abstract getBounds(): SnLonLatBounds;
  abstract fitBounds(bounds: SnLonLatBoundsLike): void;
  abstract panToBounds(bounds: SnLonLatBoundsLike): void;
}
